var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 4,
    fill: "#E6F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.5H12.5C11.9696 8.5 11.4609 8.71071 11.0858 9.08579C10.7107 9.46086 10.5 9.96957 10.5 10.5V26.5C10.5 27.0304 10.7107 27.5391 11.0858 27.9142C11.4609 28.2893 11.9696 28.5 12.5 28.5H24.5C25.0304 28.5 25.5391 28.2893 25.9142 27.9142C26.2893 27.5391 26.5 27.0304 26.5 26.5V14.5M20.5 8.5L26.5 14.5M20.5 8.5V14.5H26.5M22.5 19.5H14.5M22.5 23.5H14.5M16.5 15.5H14.5",
    stroke: "#008080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.c77f7ab41acc2b4a61657551a9f29476.svg";
export { ForwardRef as ReactComponent };